<!-- The following is a popup dialog to select a pass type -->

<p-dialog appendTo="body" header="Select Pass Type" [(visible)]="displayPassTypeDialog" [focusOnShow]="false" 
        [responsive]="true" styleClass="wal-dialog"
        showEffect="fade" [modal]="true"  [style]="{width: '15%'}" position="topleft" [showHeader]="true">

    <div class="ui-g">
        <div class="col-12">

            <p-table #dt [columns]="passTypeCols" [value]="passTypesList()" selectionMode="single" 
                [(selection)]="selectedPassType"  
                sortMode="multiple" (onRowSelect)="onRowPassTypeSelect($event)" [paginator]="false" [rows]="5" >

                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                  </tr>
              </ng-template>
            </p-table> 
      
        </div>
    </div>


    <ng-template #footer>

        <div class="footer-actions">
            <button type="button" pButton icon="fa fa-check" (click)="onPassTypeSelect()" label="Select"></button>
            <button type="button" pButton icon="fa fa-check" (click)="onCancelPassTypeSelect()" label="Cancel"></button>
        </div>
    </ng-template>

</p-dialog>



